// src/components/songEdit/hooks/useSongForm.ts
import { useState, useEffect } from 'react';
import { SongFormData } from '../types/songEdit';
import { Person } from '../types/composerTypes';

export const useSongForm = (
  initialData: SongFormData,
  onFormChange: (data: SongFormData) => void
) => {
  const [formData, setFormData] = useState<SongFormData>(initialData);

  useEffect(() => {
    setFormData(initialData);
  }, [initialData]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    const newData = { ...formData, [name]: value };
    setFormData(newData);
    onFormChange(newData);
  };

  const updateComposer = (composer: Person | null) => {
    const newData = {
      ...formData,
      composer: composer?.full_name || '',
      composerData: composer || undefined,
      composer_id: composer?.composer_id  // Explicitly set composer_id
    };
    console.log('[useSongForm] Updating composer:', { 
      composer, 
      newData: { 
        composer: newData.composer, 
        composerData: newData.composerData,
        composer_id: newData.composer_id 
      },
      composerEra: composer?.era,
      composerOrigin: composer?.origin
    });
    setFormData(newData);
    onFormChange(newData);
  };

  const updateLyricist = (lyricist: Person | null) => {
    const newData = {
      ...formData,
      lyricist: lyricist?.full_name || '',
      lyricistData: lyricist || undefined,
      lyricist_id: lyricist?.composer_id  // Explicitly set lyricist_id
    };
    console.log('[useSongForm] Updating lyricist:', { 
      lyricist, 
      newData: { 
        lyricist: newData.lyricist, 
        lyricistData: newData.lyricistData,
        lyricist_id: newData.lyricist_id 
      } 
    });
    setFormData(newData);
    onFormChange(newData);
  };

  const handleTagsChange = (tags: string[]) => {
    const newData = { ...formData, tags };
    setFormData(newData);
    onFormChange(newData);
  };

  return {
    formData,
    handleInputChange,
    updateComposer,
    updateLyricist,
    handleTagsChange
  };
};